<template>
    <b-col class="px-2">
        <div class="d-flex align-items-center">
            <i v-bind:class="sectionIcon"></i>
            <span style="font-size:12px" class="ml-1 text-uppercase">{{
                section
            }}</span>
        </div>
        <div
            :class="[
                hasBorder ? 'bordered p-1 p-md-2' : '',
                'mt-1 d-flex flex-column justify-content-center',
            ]"
        >
            <slot></slot>
        </div>
    </b-col>
</template>

<script>
export default {
    name: 'SectionSlot',
    props: {
        section: {
            type: String,
            required: true,
        },
        sectionIcon: {
            type: String,
            required: true,
        },
        hasBorder: {
            type: Boolean,
            default: true,
        },
    },
}
</script>

<style scoped>
.bordered {
    border: 1px solid #cac7c7;
    border-radius: 5px;
    height: fit-content;
}

.col {
    color: #6f6f6f;
}
</style>
